module.exports = __webpack_public_path__ + "img/output-onlinegiftools (30).e1eed98b.gif";